import { render } from "./InstructionKommoPage.vue?vue&type=template&id=e597bcf0&scoped=true"
import script from "./InstructionKommoPage.vue?vue&type=script&lang=js"
export * from "./InstructionKommoPage.vue?vue&type=script&lang=js"

import "./InstructionKommoPage.vue?vue&type=style&index=0&id=e597bcf0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e597bcf0"]])

export default __exports__